import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';

const initialState = []


export default function appReducer(state = initialState, action) {
  // console.log("----action----", action)
  switch (action.type) {
    case types.ADD_INSTANCE: {
      return [
        ...state,
        action.payload
      ]
    }

    case types.EDIT_INSTANCE: {
      return [...state.map(instance => instance.id == action.payload.id ? (action.payload) : ({ ...instance }))]
    }

    case types.DELETE_INSTANCE: {
      return state.filter(instance => instance.id !== action.payload.id)
    }

    case types.UPDATE_FULL_INSTANCES: {
      return [
        ...state,
        ...action.payload
      ]
    }

    case types.RESET_INSTANCES: {
      return [
        ...action.payload
      ]
    }

    case 'RESET_BLUEPRINT':
      return cloneDeep(initialState);

    default:
      return state;
  }
}